import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Articles from "./pages/Articles";
import LifeAfterGraduate from "./articles/life-after-graduate";
import MembukaHasilTabunganFreelance from "./articles/membuka-hasil-tabungan-freelance";
import HackerFilm from "./articles/jadi-hacker-kaya-di-film-film";
import JsPhising from "./articles/drop-js-phising-on-windows";
import TrialLead from "./articles/mencoba-jadi-team-lead-satu-bulan";


class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Header />
        <Routes>
          <Route
            path="/membuka-hasil-tabungan-freelance"
            element={<MembukaHasilTabunganFreelance />}
          />
          <Route path="/mencoba-jadi-team-lead-satu-bulan" element={<TrialLead />} />
          <Route path="/drop-js-phising-on-windows" element={<JsPhising />} />
          <Route path="/jadi-hacker-kaya-di-film" element={<HackerFilm />} />
          <Route path="/life-after-graduate" element={<LifeAfterGraduate />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/" element={<Home />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    );
  }
}

export default App;
